import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { FileText, Download, ArrowRight } from 'lucide-react';
import { DOCUMENTS } from '../data/constants';
export function Documents() {
  return <div className="flex flex-col w-full" data-id="element-1413" data-mp="2qs5ovw733u40">
      <PageHeader title="Documents Utiles" subtitle="Retrouvez ici l'ensemble des documents téléchargeables concernant notre CFA, nos formations et notre démarche qualité." data-id="element-1414" data-mp="2mozjsrvpk8z4" />

      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-1415" data-mp="2cy4x5mejv7d5">
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1416" data-mp="27zldxtrcc9oh" />
        <div className="container max-w-4xl mx-auto relative z-10" data-id="element-1417" data-mp="22zffnuqkfoxf">
          <div className="grid gap-6" data-id="element-1418" data-mp="1yz5cepu5rcm9">
            {DOCUMENTS.map(doc => <Card key={doc.id} className="border-none shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 bg-white group" data-id="element-1419" data-mp="1z19dl00o9xiu">
                <CardContent className="p-6 md:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6" data-id="element-1420" data-mp="n6gu1smhtgrc">
                  <div className="flex items-start gap-5" data-id="element-1421" data-mp="deb38m7z95dq">
                    <div className="w-14 h-14 bg-lavande rounded-2xl flex items-center justify-center shrink-0 mt-1 sm:mt-0 group-hover:scale-110 transition-transform duration-300" data-id="element-1422" data-mp="dcrncwq8gwch">
                      <FileText className="w-7 h-7 text-brand-orange" data-id="element-1423" data-mp="162zy43ifweh1" />
                    </div>
                    <div data-id="element-1424" data-mp="s377e86wxy92">
                      <h3 className="font-extrabold font-heading text-xl text-primary-dark mb-2 group-hover:text-primary transition-colors" data-id="element-1425" data-mp="s636hzuhysz3">
                        {doc.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1426" data-mp="3cwc2vsgxv15a">
                        {doc.description}
                      </p>
                    </div>
                  </div>

                  {doc.url ? <Button variant="outline" className="shrink-0 w-full sm:w-auto border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold py-6 px-6" asChild data-id="element-1427" data-mp="1id7pd0rl1jbg">
                      <a href={doc.url} download data-id="element-1428" data-mp="18lv6uzroc5i3">
                        <Download className="w-5 h-5 mr-2" data-id="element-1429" data-mp="14mmd3uwmw7mj" />
                        Télécharger
                      </a>
                    </Button> : <Button variant="outline" className="shrink-0 w-full sm:w-auto border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold py-6 px-6" asChild data-id="element-1430" data-mp="unwufzwwyj58">
                      <Link to={doc.to as string} data-id="element-1431" data-mp="2p1elvy0fw05j">
                        Consulter
                        <ArrowRight className="w-5 h-5 ml-2" data-id="element-1432" data-mp="2k3mj28y9atmk" />
                      </Link>
                    </Button>}
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </div>;
}